"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ippField_1 = require("./ippField");
var paxField_1 = require("./paxField");
var price_1 = require("./price");
var State = /** @class */ (function () {
    function State() {
        this.primaryPaxId = 0;
        this.price = new price_1.Price(0, 0, 0);
        this.email = new paxField_1.PaxField('email', 'email', 'Email');
        this.prefix = new paxField_1.PaxField('prefix', 'text', 'Vorwahl');
        this.phone = new paxField_1.PaxField('phone', 'text', 'Telefonnummer');
        this.address = new paxField_1.PaxField('address', 'text', 'Straße und Hausnummer');
        this.zipCode = new paxField_1.PaxField('zipCode', 'text', 'PLZ');
        this.city = new paxField_1.PaxField('city', 'text', 'Ort');
        this.postalCountryCode = new paxField_1.PaxField('postalCountryCode', 'select', 'Land');
        this.countryCode = new paxField_1.PaxField('countryCode', 'select', 'Land');
        this.ippField = new ippField_1.IppField();
        this.allFieldsValid = false;
        this.formValidations = {};
        this.paymentCountries = [];
        this.tradingConditionsAccepted = false;
        this.tradingConditionsAcceptedHasError = false;
        this.formSheetPauschal = false;
        this.formSheetPauschalHasError = false;
        this.insuranceBooked = false;
        this.insuranceConditionsAccepted = false;
        this.insuranceConditionsAcceptedHasError = false;
        this.covidNoteAccepted = false;
        this.covidNoteAcceptedHasError = false;
        this.ippBooked = false;
        this.formPDF = null;
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map